import { AxiosError } from "axios";

export const isAxiosError = (e: any): e is AxiosError => !!e && !!e.isAxiosError;
